import { CmsComponentsBase } from '@/cmsComponents/base';
import { CmsComponentsESol } from '@/cmsComponents/esol';

const cmsComponents = {
  ...CmsComponentsBase,
  ...CmsComponentsESol,
};

export default cmsComponents;
